module.exports = __webpack_public_path__ + "static/scale-model-of-sixth-string-guitar-statue-in-austin-texas-e273aa04f7ee1fff66a3a5f771640e8c.png";